import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import { useSelector } from 'react-redux'
import TableRowViewLC from './TableRowViewLC'
import TableRowLevels from '../GuttmanChart/TableRowLevels'
import ContextMenuContent from './ContextMenu'
import DialogNote from '../Note/Note'
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

const initialState = {
  mouseX: null,
  mouseY: null
}

const TableGuttmanChart = ({
  students,
  lcs,
  loading,
  completed,
  completedType,
  onMarking,
  minMarking,
  maxMarking
}) => {
  const studentsLoading = useSelector((state) => state?.classMarking?.studentsLoading)
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const marking = currentCurriculum?.marking || []
  const levels = currentCurriculum?.levels || []
  const size = 27

  const userId = useSelector((state) => state?.session?.user?.userId || '')
  const { classId, curriculumId, ulId } = useParams()
  const hideLevelsKey = `hideLevels_${userId}_${classId}_${curriculumId}_${ulId}`
  const [dataHideLevels, setDataHideLevels] = useState({})

  useEffect(() => {
    const readHideLevels = () => {
      const data = localStorage.getItem(hideLevelsKey) ? JSON.parse(localStorage.getItem(hideLevelsKey)) : {}
      setDataHideLevels(data || {})
    }
    readHideLevels()
    const handleStorage = (event) => {
      if (event.key && event.key !== hideLevelsKey) return
      readHideLevels()
    }
    const handleCustom = (event) => {
      if (event?.detail?.key && event.detail.key !== hideLevelsKey) return
      readHideLevels()
    }
    window.addEventListener('storage', handleStorage)
    window.addEventListener('hide-levels-updated', handleCustom)
    return () => {
      window.removeEventListener('storage', handleStorage)
      window.removeEventListener('hide-levels-updated', handleCustom)
    }
  }, [hideLevelsKey])

  const [state, setState] = useState(initialState)
  const [noteDialog, setNoteDialog] = useState(null)

  const handleClick = (event, item) => {
    event.preventDefault()
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
      item
    })
  }

  const handleClose = (event, item) => {
    event.preventDefault()

    if (item && state.item) {
      if (item.type === 'marking') {
        const markinglevel = state.item
        markinglevel.completed = item._id
        if (onMarking && markinglevel.completed) {
          onMarking(markinglevel)
        }
      }
      if (item.type === 'note') {
        setNoteDialog({
          lcId: state.item.lcId,
          levelId: state.item.levelId,
          gsId: state.item.gsId,
          studentId: state.item.studentId
        })
      }
    }
    setState(initialState)
  }

  return (
    <TableContainer className='absolute inset-0 flex flex-col'>
      <Table className='w-fit'>
        <TableBody>
          <TableRowLevels
            lcs={lcs}
            levels={levels}
            currentCurriculum={currentCurriculum}
            size={size}
            dataHideLevels={dataHideLevels}
          />
          {[...students]
            .sort((a, b) => b?.code - a?.code)
            .map((student, index) => {
              return (
                <TableRowViewLC
                  key={`guttman-chart-table-student-${student._id}`}
                  completed={completed}
                  student={student}
                  lcs={student.lcs || lcs}
                  marking={marking}
                  levels={levels}
                  index={index}
                  currentCurriculum={currentCurriculum}
                  size={size}
                  isLoading={studentsLoading || loading}
                  onMarking={onMarking}
                  minMarking={minMarking}
                  maxMarking={maxMarking}
                  onContextMenu={handleClick}
                  dataHideLevels={dataHideLevels}
                />
              )
            })}
        </TableBody>
      </Table>
      <ContextMenuContent state={state} handleClose={handleClose} completed={completed} />
      {noteDialog && (
        <DialogNote
          open={!!noteDialog}
          onClose={() => setNoteDialog(null)}
          formData={noteDialog}
          type='edit'
          studentId={noteDialog.studentId}
        />
      )}
    </TableContainer>
  )
}

export default TableGuttmanChart
